// Core
//
import { Controller } from 'stimulus';

export default class extends Controller {
  toggle(event: Event) {
    const btn = event.currentTarget as HTMLButtonElement | null;
    if (!btn) return;

    const targetId = btn.dataset.targetId;
    if (!targetId) return;
    const container = document.getElementById(targetId);
    if (!container) return;

    const isHidden = container.hasAttribute('hidden');
    if (isHidden) {
      container.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('span')!.textContent = '▾';
    } else {
      container.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('span')!.textContent = '▸';
    }
  }
}

